import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { includes } from 'lodash';
import moment from 'moment';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { setSelectedDate, clearSelectedDate } from 'store/leaveSlice';
import { Flex } from 'atoms';

const Container = styled(Flex)`
	flex-direction: column;
	justify-content: space-between;
	width: 95%;
	margin: 5px 10px;
	border-radius: 22px;
	background-color: ${(props) => props.theme.colors.white};
	div {
		margin: 5px 0;
		justify-content: space-between;
		text-align: center;
		div {
			@media (max-width: 370px) {
				margin: 10px 0;
			}
		}
	}
	p {
		display: inline-block;
		width: 30px;
		padding: 10px 9px;
		margin: 0 10px;
		font-size: 12px;
		text-align: center;
		@media (max-width: 370px) {
			margin: 0 8px;
		}
	}
`;

const DayDiv = styled.p`
	color: ${(props) => props.theme.colors.CelticBlue};
`;

const DayColor = (props) => {
	if (props.day.isBefore(new Date(), 'day')) return props.theme.colors.GrayX;
	// if (props.day.isSame(new Date(), 'day')) return props.theme.colors.NightRider;
	if (includes(props.applyDate, moment(props.day).format())) return props.theme.colors.white;

	// eslint-disable-next-line sonarjs/no-duplicate-string
	if (includes(props.pending, moment(props.day).format('YYYY-MM-DD')))
		return props.theme.colors.white;
	if (includes(props.approved, moment(props.day).format('YYYY-MM-DD')))
		return props.theme.colors.white;

	return props.theme.colors.NightRider;
};

const DaybgColor = (props) => {
	// if (props.day.isSame(new Date(), 'day')) return props.theme.colors.white;
	if (includes(props.applyDate, moment(props.day).format())) return props.theme.colors.CelticBlue;
	if (includes(props.pending, moment(props.day).format('YYYY-MM-DD')))
		return props.theme.colors.YellowOrg;
	if (includes(props.approved, moment(props.day).format('YYYY-MM-DD')))
		return props.theme.colors.Emerald;

	return props.theme.colors.white;
};

const DayStyle = styled.p`
	font-size: 17px;
	font-weight: 500;
	border-radius: 8px;
	text-align: center;
	color: ${(props) => DayColor(props)};
	background-color: ${(props) => DaybgColor(props)};
	pointer-events: ${(props) =>
		(props.day.isBefore(new Date(), 'day') ||
			includes(props.pending, moment(props.day).format('YYYY-MM-DD')) ||
			includes(props.approved, moment(props.day).format('YYYY-MM-DD'))) &&
		'none'};
`;

export default function CalendarMonth({ selectedMonth }) {
	const [isSelected, setIsSelected] = useState(moment());
	const dispatch = useDispatch();
	const { selectedDate, leaveListData = [] } = useSelector((state) => state.leave);
	const startDay = moment().add(`${selectedMonth}`, 'M').startOf('month').startOf('week');
	const endDay = moment().add(`${selectedMonth}`, 'M').endOf('month').endOf('week');
	const day = startDay.clone().subtract(1, 'day');
	const calendar = [];
	const approved = [];
	const pending = [];

	while (day.isBefore(endDay, 'day')) {
		calendar.push(
			Array(7)
				.fill(0)
				.map(() => day.add(1, 'day').clone())
		);
	}

	leaveListData.map((dt) =>
		dt.map((ar) => {
			if (ar.status === 'Approved') approved.push(ar.date);
			if (ar.status === 'Pending') pending.push(ar.date);

			return [];
		})
	);

	function handleChange(dayy) {
		if (includes(selectedDate, moment(dayy).format())) {
			const removeDay = selectedDate.filter((dt) => dt !== moment(dayy).format());

			dispatch(clearSelectedDate(removeDay));
		} else dispatch(setSelectedDate(moment(dayy).format()));
	}

	return (
		<Container>
			<div>
				{calendar[0].map((weekday) => (
					<DayDiv key={weekday}>{moment(weekday).format('dd')}</DayDiv>
				))}
			</div>
			<div>
				{calendar.map((week) => (
					<div key={week}>
						{week.map((dayy) => (
							<DayStyle
								onClick={() => {
									setIsSelected(dayy);
									handleChange(dayy);
								}}
								day={dayy}
								key={dayy}
								leaveData={leaveListData}
								sday={isSelected}
								applyDate={selectedDate}
								approved={approved}
								pending={pending}
							>
								{dayy.format('D')}
							</DayStyle>
						))}
					</div>
				))}
			</div>
		</Container>
	);
}

CalendarMonth.propTypes = {
	selectedMonth: PropTypes.number,
};
